import { render } from "./DataFoto.vue?vue&type=template&id=da44b1c0&scoped=true"
import script from "./DataFoto.vue?vue&type=script&lang=js"
export * from "./DataFoto.vue?vue&type=script&lang=js"

import "./DataFoto.vue?vue&type=style&index=0&id=da44b1c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da44b1c0"]])

export default __exports__